

/***********************************
  Quad NAMESPACE
************************************/

window.Quad = ( typeof window.Quad == 'undefined' ) ? {} : window.Quad;


/***********************************
  Main Module
************************************/

Quad.Main = ( function() {


  // PRIVATE METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  function _init() {

    Quad.Home.init();
    Quad.Menu.init();
    Quad.Hopscotch.init();
    Quad.GeneralContent.init();
    Quad.CheckboxRadios.init();
    Quad.FormHandlers.init();
    Quad.ContactFormSelector.init();
    Quad.FAQ.init();
    Quad.SectionInertia.init();
    Quad.SocialShare.init();
    Quad.DownloadICS.init(); 

    $( '.lazy' ).lazy({
      effect: 'fadeIn',
      effectTime: 300,
      threshold:500,
      bind: 'event' 
    });

  }


  // PUBLIC METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  return {

    init: _init

  };


})();


/***********************************
  Handlebars external template

  usage example:
  this will retrieve the '/theme/Quad/templates/blog.html':

  var template = Handlebars.getTemplate('blog');
  var templateModel = {
    posts: jsonData
  };
  var html = template(templateModel);
  $("#content").append(html);

************************************/
// Handlebars.getTemplate = function (name) {
//   if (Handlebars.templates === undefined || Handlebars.templates[name] === undefined) {
//     $.ajax({
//       url: '/theme/Quad/templates/' + name + '.html',
//       success: function (data) {
//         if (Handlebars.templates === undefined) {
//           Handlebars.templates = {};
//         }
//         Handlebars.templates[name] = Handlebars.compile(data);
//       },
//       async: false
//     });
//   }
//   return Handlebars.templates[name];
// };
